module.exports = __webpack_public_path__ + "img/icon-vot-pendingonline.c131add9.png";